/**
 * @file plans.ts
 *
 * The WSB-v2 project plan slugs the shop admin cares about, isolated so the
 * vocabulary stays shared and stable. Mirrors website-builder's
 * `apps/client/src/shared/constants/plans.ts` and the commerce-engine copy. Kept
 * separate from the {@link ./eligibility} rule that consumes them so other UI can
 * reference a plan slug without importing the predicate.
 */

/** Project plan slug granting commerce outright. */
export const COMMERCE_PLAN = 'WSBV2_COMMERCE';

/** Project plan slug granting commerce while the trial is live. */
export const TRIAL_PLAN = 'TRIAL';
